import { render, staticRenderFns } from "./TransferPutaway.vue?vue&type=template&id=7e28dcb6"
import script from "./TransferPutaway.vue?vue&type=script&lang=js"
export * from "./TransferPutaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports